import React, { useState } from 'react'
import { useDispatch } from 'react-redux';

import { Dialog, DialogContent, DialogTitle, Grid, Button } from "@material-ui/core";
import { ValidatorForm } from 'react-material-ui-form-validator';

import Buscador from '../../../../actions/ui/Buscador';
import { postCuentasContables } from '../../../../actions/contrataciones/contratacionesDatosContables';

const centerStyle = {display: "flex", justifyContent: "flex-end", alignItems: "center"};

export const ModalAddCuenta = ({open, setOpen, idEfectorFacturacion}) => {
    const dispatch = useDispatch();

    const [cuentaValue, setCuentaValue] = useState(null);

    const submitHandler = (e) => {
        e.preventDefault();

        dispatch(postCuentasContables({
            idEfectorFacturacion,
            idPlandeCuenta: cuentaValue.id
        }, setOpen));
    }

    return (
        <Dialog open={open} fullWidth maxWidth={"sm"}>
            <DialogTitle id="form-dialog-title">Agregar Cuenta Contable</DialogTitle>
            <DialogContent>
                <ValidatorForm onSubmit={submitHandler}>
                    <Grid container spacing={2} style={{display: "flex", flexDirection: "column"}}>
                        <Grid item xs={12}>
                            <Buscador 
                                value={cuentaValue}
                                variant="outlined"
                                setValue={(val) => setCuentaValue(val)}
                                label="Plan de Cuentas" 
                                endpoint={(texto) => `PlanCuentas/traerPorParametros?texto=${texto.replace("/", "__")}`}
                                noOptionText={"No se encuentra plan cuentas"}
                                getOptionLabel={(option) =>`${option.cuenta}-${option.subCuenta} - ${option.descripcion}`}
                                renderOption={(option) =>`${option.cuenta}-${option.subCuenta} - ${option.descripcion}`}
                                validators={{
                                    values: ["required"],
                                    msgs: ["Este campo es obligatorio"]
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} style={{...centerStyle, gap: "1em", margin: "0.5em"}}>
                            <Button
                                variant='outlined'
                                type='button'
                                color='secondary'
                                onClick={() => setOpen(false)}
                            >
                                Cerrar
                            </Button>
                            <Button
                                variant='contained'
                                color='primary'
                                type="submit"
                            >
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </ValidatorForm>
            </DialogContent>
        </Dialog>
    )
}
